<div class="container-fluid page">
  <!-- <button class="close" mat-button (click)="onClear()">X</button> -->

  <!-- <form [formGroup]="dateForm"> -->

    <!-- <mat-form-field appearance="fill">
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input [rangePicker]="picker"  [locale]="{applyLabel: 'ok', format: 'DD/MM/YYYY'}" style="color: black;">
      <input matStartDate placeholder="Start date">
      <input matEndDate placeholder="End date">
    </mat-date-range-input>
    <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint> -->
    <!-- <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>&nbsp; -->
    <mat-form-field>
      <input type="text" matInput
      ngxDaterangepickerMd
      [locale]="{applyLabel: 'ok', format: 'DD-MM-YYYY'}"
      startKey="start"
      endKey="end"
   
      name="daterange"/>
      <!-- <label for="exampleInputEmail1">The range date</label> -->
      <!-- <input matInput type="text" name="daterange" placeholder="Enter a date range" autocomplete="off"
        [dateLimit]="dateLimit" [alwaysShowCalendars]="true" ngxDaterangepickerMd [(ngModel)]="sharedate"
        [locale]="{applyLabel: 'ok', format: 'DD/MM/YYYY'}" [showCustomRangeLabel]="true"
        (change)="onDateRangeChanged($event)" /> -->
    </mat-form-field>&nbsp;
    <!-- <mat-error *ngIf="dateForm.get('dateLimit').hasError('dateLimit')">
      Invalid maximum date.
    </mat-error> -->
    <!-- </form> -->
    <!-- <mat-form-field> 
    <input matInput [matDatepicker]="picker" placeholder="Choose a date">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker ></mat-datepicker>
  </mat-form-field> -->
    <!-- <mat-checkbox style=" position: absolute; top:-16px; right:-12px;" name="list_name"></mat-checkbox> -->
    <!-- <mat-checkbox  class="largerCheckbox"
  style="color: black;" name="All">All</mat-checkbox> -->


    <!-- <button mat-raised-button class="btn btncls" style="   
   margin-right: -15px;
    margin-left: 210px;
    width: 81px;
    height: 36px;
    margin-top: 22px;" (click)="onSync()">Sync</button> -->
    <!-- <button mat-raised-button class="btn btncls2" style="    margin-left: 23px;color: white;
  background-color: #234a90;" (click)="closeDialogtest()">Cancel</button> -->
</div>
<style>


</style>

